<template>
  <div class="updateDetail">
    <div class="section">
      <div class="user">
        <img class="avatar" :src="require('@/assets/images/avatar_03.png')" />
        <div class="info">
          <div class="name">野原新之助</div>
          <div class="date">2021.11.1 11:56</div>
        </div>
      </div>
      <div class="textarea">今天天气真好！</div>
      <div class="imgWrap">
        <div class="item" v-for="item in 3" :key="item">
          <img class="img" :src="require('@/assets/images/image_02.png')" @click="imgPreview" />
        </div>
      </div>
      <div class="record">
        <div class="item"  @click="status = !status">
          <img class="icon" :src="status?require('@/assets/images/issue/icon_zan_02.png'):require('@/assets/images/issue/icon_zan_01.png')" />
          <span :class="{ active:status }">888</span>
        </div>
        <div class="item" @click="popupShow">
          <img class="icon" :src="require('@/assets/images/issue/icon_comment_01.png')" />
          <span>666</span>
        </div>
      </div>
    </div>
    <div class="commtents">
      <div class="statistics">
        <div class="line"></div>
        <span>{{ `共${page.list.length || 0}条评论` }}</span>
      </div>
      <van-pullRefresh v-model="page.refreshing" @refresh="onRefresh">
        <van-List
          v-model="page.loading"
          :finished="page.finished"
          @load="onLoad"
        >
          <CommentItem v-for="(item,index) in page.list" :key="index" @comment="popupShow" />
          <template #finished>
            <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
          </template>
        </van-List>
      </van-pullRefresh>
    </div>
    <div class="footer">
      <div class="icons">
        <div class="item" @click="status = !status">
          <img class="icon" :src="status?require('@/assets/images/issue/icon_zan_03.png'):require('@/assets/images/issue/icon_zan_01.png')" />
          <span>{{ status?'已点赞':'点赞' }}</span>
        </div>
      </div>
      <div class="box" @click="popupShow">写下你的评论...</div>
    </div>
    <van-popup class="popup" v-model="show" position="bottom">
      <van-field
        ref="getFocus"
        class="message"
        :autofocus="true"
        v-model="message"
        autosize
        type="textarea"
        placeholder="说点什么...."
      />
      <button @click="popupCancel">发送</button>
    </van-popup>
  </div>
</template>

<script>
import { Field, ImagePreview } from 'vant';
import CommentItem from './components/CommentItem';
export default {
  name: 'updateDetail',
  components: { 'van-field': Field, CommentItem },
  data () {
    return {
      show: false,
      message: '',
      status: false,
      page: {
        list: [],
        loading: false,
        finished: false,
        refreshing: false
      }
    };
  },
  created () {
    this.onLoad();
  },
  methods: {
    imgPreview () {
      ImagePreview(['https://img01.yzcdn.cn/vant/apple-1.jpg']);
    },
    popupShow () {
      this.show = true;
      this.$nextTick(() => {
        this.$refs.getFocus.focus();
      });
    },
    popupCancel () {
      this.show = false;
    },
    onLoad () {
      setTimeout(() => {
        if (this.page.refreshing) {
          this.page.list = [];
          this.page.refreshing = false;
        }

        for (let i = 0; i < 5; i++) {
          this.page.list.push({ status: i % 2 === 0 ? 1 : 2 });
        }
        this.page.loading = false;

        if (this.page.list.length >= 20) {
          this.page.finished = true;
        }
      }, 200);
    },
    onRefresh () {
      // 清空列表数据 重新加载数据
      this.page = {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: true,
        finished: false,
        refreshing: true
      };
      this.onLoad();
    }
  }
};
</script>

<style lang="less" scoped>
.updateDetail {
  padding-bottom: 100px;
  .section {
    padding: 40px 26px;
    .user {
      display: flex;
      align-items: center;
      .avatar {
        width: 80px;
        height: 80px;
      }
      .info {
        height: 80px;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
          font-size: 28px;
          color: #333333;
        }
        .date {
          font-size: 24px;
          font-weight: 500;
          color: #999AAA;
        }
      }
    }
    .textarea {
      margin: 30px 0;
      font-size: 28px;
      font-weight: 500;
      color: #333444;
    }
    .imgWrap {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-bottom: 20px;
        width: 33.3%;
        display: flex;
        align-items: center;
        justify-content: center;
        .img {
          width: 218px;
          height: 166px;
          background: #FFFFFF;
          border: 2px solid #707070;
          border-radius: 8px;
        }
      }
    }
    .record {
      margin-top: 20px;
      display: flex;
      align-items: center;
      .item {
        margin-right: 48px;
        display: flex;
        align-items: center;
        .icon {
          width: 32px;
          height: 32px;
        }
        span {
          margin-left: 8px;
          font-size: 24px;
          font-weight: 500;
          color: #999AAA;
        }
        .active {
          color: #F6BE64;
        }
      }
    }
  }
  .commtents {
    background-color: #F7F8FA;
    overflow: hidden;
    .statistics {
      margin: 20px 0;
      padding: 30px 28px;
      background-color: #fff;
      display: flex;
      align-items: center;
      .line {
        width: 8px;
        height: 32px;
        background: #5FA9FF;
        border-radius: 4px;
      }
      span {
        margin-left: 20px;
        font-size: 28px;
        font-weight: 400;
        color: #333444;
      }
    }
  }
  .footer {
    width: 100%;
    height: 100px;
    background: #fff;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    right: 0;
    bottom: 0;
    .icons {
      display: flex;
      align-items: center;
      .item {
        width: 110px;
        height: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .icon {
          width: 32px;
          height: 32px;
        }
        span {
          margin-top: 4px;
          font-size: 20px;
          font-weight: 500;
          color: #333444;
        }
      }
    }
    .box {
      padding: 20px 40px;
      margin-right: 28px;
      width: 450px;
      height: 76px;
      background: #F6F6F6;
      border-radius: 60px;
      font-size: 26px;
      font-weight: 400;
      color: #C1C1C1;
      display: flex;
      align-items: center;
    }
  }
  .popup {
    padding: 40px 30px;
    height: 200px;
    background: #fff;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
    border-radius: 20px 20px 0px 0px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .message {
      flex: 1;
      height: 120px;
      margin-right: 30px;
      background: #F8F8FA;
      border-radius: 10px;
    }
    button {
      width: 112px;
      height: 48px;
      background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
      border-radius: 26px;
      font-size: 26px;
      font-weight: 500;
      color: #fff;
    }
  }
}
</style>